<template>
  <v-card class="video-card" v-if="videoObj" :loading="!videoObj || videoObj.loading" height="100%">
    <v-img
      :aspect-ratio="16/9"
      @click="loadVideo"
      :src="imageUrl"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.7)"
      height="200px"
    >
      <v-card-title class="video-card-title">
        {{videoObj.name}}
      </v-card-title>
    </v-img>
    <v-card-text class="pb-0 mb-6" v-if="videoObj.description">{{ videoObj.description }}</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" :loading="saving_favorite" @click="toggleFavorite">
            <v-icon v-if="favorite" color="red lighten-1">favorite</v-icon>
            <v-icon v-else>favorite_outline</v-icon>
          </v-btn>
        </template>
        <span v-if="favorite">{{ $t('library.tooltips.remove-favorite') }}</span>
        <span v-else>{{ $t('library.tooltips.add-favorite') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="loadVideo">
            <v-icon>play_circle_outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('library.tooltips.play') }}</span>
      </v-tooltip>
    </v-card-actions>
    <video-player
      :video="videoObj"
      v-if="play"
      v-on:close="closeVideo"
      v-on:toggleFavorite="toggleFavorite"
    ></video-player>
  </v-card>
</template>

<style lang="scss">
.video-card {
  &.v-card {
    position: relative;
    padding-bottom: 3em;
    .v-card__actions {
      width: 100%;
      text-align: right;
      border-top: 1px solid #E0E0E0;
      position: absolute;
      bottom: 0;
    }
    .v-card__text {
      max-height: 7em;
      overflow: hidden;
      line-height: 1.5em;
    }
  }
}
</style>

<script>

import { addFavorite, removeFavorite } from '@/store/module/favorite'
import { getDocById } from '@/store/module/explore'
import { getUrlImage } from '@/store/storage'
import VideoPlayerComponent from '@/components/VideoPlayer'

export default {
  name: 'video-card',
  components: {
    'video-player': VideoPlayerComponent
  },
  data: () => ({
    play: false,
    imageUrl: '',
    videoObj: null,
    favorite: false,
    saving_favorite: false
  }),
  props: {
    video: null,
    id_video: null
  },
  created() {
    if (this.video) {
      this.fillVideo(this.video)
    } else if (this.id_video) {
      this.getVideo()
    }
  },
  methods: {
    getVideo() {
      getDocById('videos', this.id_video)
      .get()
      .then(result => {
        let video = {
          id: result.id,
          ...result.data()
        }
        this.fillVideo(video)
      })
      .catch(error => {
        console.log('Error getting video', error.message);
      })
    },
    fillVideo(video) {
      this.videoObj = video
      this.videoObj.loading = true
      getUrlImage(this.videoObj.image).then(url => {
        this.imageUrl = url
        this.videoObj.loading = false
      })

      this.favorite = this.$store.getters.user.favorites.includes(video.id)
    },
    toggleFavorite() {
      this.saving_favorite = true
      let action = this.favorite ? removeFavorite : addFavorite
      action(this.videoObj.id)
      .then(success => {
        if (success) {
          let favorites = this.$store.getters.user.favorites
          if (this.favorite) {
            favorites = favorites.filter(f => f !== this.videoObj.id)
          } else {
            favorites.push(this.videoObj.id)
          }
          this.$store.dispatch('setFavorites', favorites)
          this.favorite = !this.favorite
        }
        this.saving_favorite = false
      })
      .catch(() => {
        this.saving_favorite = false
      })
    },
    closeVideo() {
      this.play = false
    },
    loadVideo() {
      this.play = true
    }
  }
}

</script>
